export enum CommonMutationType {
  SET_ORDER_STATUS_LIST = 'SET_ORDER_STATUS_LIST'
}
